'use strict';exports.__esModule = true;var _extends = Object.assign || function (target) {for (var i = 1; i < arguments.length; i++) {var source = arguments[i];for (var key in source) {if (Object.prototype.hasOwnProperty.call(source, key)) {target[key] = source[key];}}}return target;};
var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _reduxForm = require('redux-form');
var _reactRouter = require('react-router');
var _reactScroll = require('react-scroll');
var _classnames = require('classnames');var _classnames2 = _interopRequireDefault(_classnames);
var _get = require('lodash/get');var _get2 = _interopRequireDefault(_get);

var _components = require('../../components');








var _constants = require('../../constants');
var _makeSharingUrl = require('../../utils/makeSharingUrl');var _makeSharingUrl2 = _interopRequireDefault(_makeSharingUrl);
var _underscoreNotationToCamelCase = require('../../utils/underscoreNotationToCamelCase');var _underscoreNotationToCamelCase2 = _interopRequireDefault(_underscoreNotationToCamelCase);


var _EditProfile = require('../../components/EditProfile/EditProfile.scss');var styles = _interopRequireWildcard(_EditProfile);
var _containers = require('../../containers');function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;} // Modules
// Components
// Helpers
// Styles
var EditProfile = function (_Component) {_inherits(EditProfile, _Component);function EditProfile() {var _temp, _this, _ret;_classCallCheck(this, EditProfile);for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {args[_key] = arguments[_key];}return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = { changeEmailFails: false }, _this.


    componentWillReceiveProps = function (_ref) {var userData = _ref.userData;
      if (userData && userData.error && userData.error !== _this.props.userData.error) {
        console.error(userData.error.message);
        switch (userData.error.status) {
          case _constants.requestErrorStatusCodes.BAD_REQUEST:
            _this.setState({ changeEmailFails: true });
            break;
          case _constants.requestErrorStatusCodes.TOKEN_VALIDATION_ERROR:
            if (userData && !userData.isAuthenticationModalOpen) {
              _this.props.openMessageModal({
                message:
                _react2.default.createElement('div', { className: 'contentMessage' },
                  _react2.default.createElement('p', null, _this.props.translate('editProfile', 'editError'))) });



            }
            break;
          default:
            _this.props.openMessageModal({
              message:
              _react2.default.createElement('div', { className: 'contentMessage' },
                _react2.default.createElement('p', null, _this.props.translate('editProfile', 'editError'))) });



            break;}

      }
    }, _this.

    onSubmit = function (evt) {
      evt.preventDefault();
      _this.props.handleSubmit();
    }, _this.

    changeImages = function (data) {
      var publicId = null;
      var image = data.length ? data[0] : {};

      if (data.length) {
        publicId = image.public_id ? image.public_id : image.full && image.full.split('/').pop();
      }

      var userImage = {
        link: publicId,
        angle: image.angle || 0 };


      _this.props.changeValue({ name: 'profile_img', value: userImage });
    }, _this.

    fetchInitialProfileImageValue = function () {
      var profileImage = _this.props.initialValues ? _this.props.initialValues.profile_img : null;
      var angle = _components.UploadAssetWidget.getAngle({ full: profileImage });
      var linkId = profileImage && profileImage.full && profileImage.full.split('/').pop();

      return profileImage ? [{
        full: profileImage,
        thumbnail: profileImage,
        _id: linkId,
        angle: angle,
        relativeAngle: 0 }] :
      [];
    }, _this.

    checkIsRequired = function (name) {return _this.props.requiredFields.indexOf(name) !== -1;}, _this.

    isVerifiedRealtor = function () {return (0, _get2.default)(_this.props, 'userData.data.agent_data.verified');}, _this.

    realtorCheckboxIsActive = function () {return !(0, _get2.default)(_this.props, 'userData.data.is_agent');}, _this.

    phoneVerificationSuccess = function (status) {return status ?
      setTimeout(function () {return _this.props.updateVerification({ phone: true });}, 1000) :
      null;}, _this.

    renderFormGroup = function (_ref2) {var input = _ref2.input,meta = _ref2.meta;
      var name = (0, _underscoreNotationToCamelCase2.default)(input.name);
      var tooltipPostfix = 'TooltipMessage';
      var titlePostfix = 'TooltipMessage';
      var tooltipMessageKey = name + tooltipPostfix;

      if (name === 'email') {
        var wrongEmailMessage = 'emailTooltipMessage';
        var changeEmailFailsMessage = 'changeEmailFailsTooltipMessage';

        tooltipMessageKey = _this.state.changeEmailFails ? changeEmailFailsMessage : wrongEmailMessage;
      }

      return _react2.default.createElement(_components.OMFormGroup, _extends({},
      input,
      meta, {
        label: '' + _this.props.translate('editProfile', name),
        tooltipMessage: '' + _this.props.translate('editProfile', tooltipMessageKey),
        title: '' + _this.props.translate('editProfile', name + titlePostfix),
        isMobile: _this.props.isMobile,
        isRequired: _this.checkIsRequired(input.name),
        isRtl: _this.props.isRtl }));

    }, _this.

    renderRealEstateCheckbox = function (field) {return (
        _react2.default.createElement(_components.RealEstateCheckbox, {
          field: Object.assign({}, field.input, { checked: field.input.value }),
          label: '' + _this.props.translate('editProfile', 'isRealEstate'),
          tooltipMsg: _this.props.translate('editProfile', 'realEstateTooltip').toString(),
          disabledTooltipMsg: _this.props.translate('editProfile', 'verifiedRealEstateTooltip').toString(),
          disabledTooltipLinkMsg: _this.props.translate('editProfile', 'verifiedRealEstateTooltipLink').toString(),
          locale: _this.props.locale,
          disabled: field.disabled }));}, _temp), _possibleConstructorReturn(_this, _ret);}EditProfile.prototype.



  render = function render() {var _cx,_this2 = this;
    var loadingUserData = this.props.userData && this.props.userData.loading;
    var userId = (0, _get2.default)(this.props, 'userData.data.id');

    return (
      _react2.default.createElement('div', {
          className: (0, _classnames2.default)('edit-profile', styles.editProfileFormWrapper, (_cx = {}, _cx[
          styles.native] = this.props.isNative, _cx)) },


        _react2.default.createElement('div', { className: styles.content },
          _react2.default.createElement('form', { onSubmit: this.onSubmit },
            _react2.default.createElement('div', { className: styles.fieldset },
              _react2.default.createElement(_reactScroll.Element, { name: 'display_name' },
                _react2.default.createElement(_reduxForm.Field, {
                  name: 'display_name',
                  props: { locale: this.props.locale },
                  component: this.renderFormGroup })),



              _react2.default.createElement(_reactScroll.Element, { name: 'email' },
                _react2.default.createElement(_reduxForm.Field, {
                  name: 'email',
                  props: { locale: this.props.locale },
                  component: this.renderFormGroup })),



              _react2.default.createElement('div', { className: styles.uploadWidget },
                _react2.default.createElement('div', { className: styles.widgetLabel },
                  this.props.translate('editProfile', 'image')),


                _react2.default.createElement('div', { className: styles.widget },
                  _react2.default.createElement(_components.UploadAssetWidget, {
                    openMessageModal: this.props.openMessageModal,
                    translate: this.props.translate('uploadWidget'),
                    rootTranslate: this.props.translate,
                    isMobile: this.props.isMobile,
                    initialImages: this.fetchInitialProfileImageValue(),
                    uploadInProgress: function uploadInProgress(status) {return _this2.setState({ uploadPhotoInProgress: status });},
                    updateContent: this.changeImages,
                    contentUploaded: this.changeImages,
                    markAssetToDelete: this.props.addAssetToDelete,
                    suspendedUpload: true,
                    userToken: (0, _get2.default)(this.props, 'userData.data.access_token') }))),




              _react2.default.createElement(_reduxForm.Field, {
                name: 'is_agent',
                props: { locale: this.props.locale },
                component: this.renderRealEstateCheckbox,
                disabled: !this.realtorCheckboxIsActive() }),


              this.props.isRealEstate &&
              _react2.default.createElement('div', { className: styles.realEstateDetailsSection },

                _react2.default.createElement(_components.RealEstateDetails, {
                  translate: this.props.translate,
                  isMobile: this.props.isMobile,
                  locale: this.props.locale,
                  registerNewField: this.props.registerNewField,
                  isRtl: this.props.isRtl })),




              _react2.default.createElement('div', { className: styles.changePasswordBlock },
                _react2.default.createElement('p', { className: 'click-here' },
                  this.props.translate('editProfile', 'editPassword'), '\xA0',

                  _react2.default.createElement('a', {
                      className: 'link',
                      onClick: function onClick() {return (
                          _this2.props.openAuthenticationModal({ bodyType: _constants.authenticationModalType.CHANGE_PASSWORD }));} },


                    this.props.translate('editProfile', 'clickHere'))))),





            _react2.default.createElement('div', { className: styles.phoneContainer },

              _react2.default.createElement(_containers.PhoneVerificationContainer, {
                isMyAccount: true,
                verificationSuccess: this.phoneVerificationSuccess,
                isRtl: this.props.isRtl })),













            this.props.isMobile &&
            _react2.default.createElement('div', { className: styles.logOut },
              _react2.default.createElement('p', { onClick: this.props.logOut },
                _react2.default.createElement('span', { className: 'icon icon-logout' }), '\xA0\xA0',
                _react2.default.createElement('span', null, this.props.translate('editProfile', 'logOut')))),




            _react2.default.createElement('div', { className: styles.buttons },
              _react2.default.createElement('div', null,
                _react2.default.createElement('button', {
                    className: styles.submitButton,
                    type: 'submit',
                    disabled: loadingUserData || !this.props.formIsDirty },

                  loadingUserData ?
                  _react2.default.createElement('i', { className: (0, _classnames2.default)('icon icon-om-spinner om-pulse', styles.spinner) }) : '' +
                  this.props.translate('editProfile', 'submit')),



                _react2.default.createElement('button', {
                    className: styles.cancelButton,
                    onClick: function onClick(evt) {
                      evt.preventDefault();
                      _this2.props.resetForm();
                      _reactRouter.browserHistory.goBack();
                    } },

                  this.props.translate('editProfile', 'cancel'))),



              !this.props.isMobile &&
              _react2.default.createElement('button', {
                  className: styles.cancelButton,
                  onClick: function onClick(evt) {
                    evt.preventDefault();
                    _this2.props.logOut();
                  } },

                this.props.translate('editProfile', 'logOut')))))));







  };return EditProfile;}(_react.Component);


EditProfile.propTypes = {
  locale: _propTypes2.default.string.isRequired,
  isMobile: _propTypes2.default.bool,
  translate: _propTypes2.default.func,
  openAuthenticationModal: _propTypes2.default.func,
  handleSubmit: _propTypes2.default.func,
  userData: _propTypes2.default.object,
  initialValues: _propTypes2.default.object,
  openMessageModal: _propTypes2.default.func,
  changeValue: _propTypes2.default.func,
  registerNewField: _propTypes2.default.func,
  addAssetToDelete: _propTypes2.default.func,
  resetForm: _propTypes2.default.func,
  logOut: _propTypes2.default.func,
  updateVerification: _propTypes2.default.func,
  location: _propTypes2.default.object,
  requiredFields: _propTypes2.default.array,
  isRealEstate: _propTypes2.default.bool,
  isRtl: _propTypes2.default.bool,
  isNative: _propTypes2.default.bool,
  formIsDirty: _propTypes2.default.bool };exports.default =


EditProfile;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/EditProfile/EditProfile.js
// module id = 2627
// module chunks = 0